module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCondIt.a80a48b.woff2";